/** @deprecated Ribbons consumers should not rely on a Ribbons component's internal implementation details */
export var LINK_CAROUSEL__HEADING_CLASS = 'link_carousel__heading';

/** @deprecated Ribbons consumers should not rely on a Ribbons component's internal implementation details */
export var LINK_CAROUSEL__CONTAINER_CLASS = 'link_carousel__container';

/** @deprecated Ribbons consumers should not rely on a Ribbons component's internal implementation details */
export var LINK_CAROUSEL__LIST_CLASS = 'link_carousel__list';